import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import Icon from '../Icon'
import { Box } from '../Layout'
import Spinner from '../../rolex-ui/VideoPlayer/Spinner'
import { breakpoints } from '../Theme'
import { AnimatedLabel } from './AnimatedLabel'
import Input, { InputProps } from './Input'
import shouldForwardProp from '@styled-system/should-forward-prop'

const Button = styled.button`
  transition: all 0.2s ease;
  outline: 0;
  height: 3rem;
  background: ${p => p.theme.colors.tabaccoLight};
  color: ${p => p.theme.colors.shades[800]};
  margin: 0;

  @media screen and (min-width: ${breakpoints.small}) {
    height: 3.5rem;
  }

  &:hover {
    color: #fff;
    background: ${p => p.theme.colors.shades[800]};
  }
  &:disabled {
    cursor: not-allowed;
  }

  @media screen and (min-width: ${breakpoints.small}) {
    padding: 0 1rem;
  }
`
const Container = styled(Box).withConfig({
  shouldForwardProp
})<{ status: string; hasError: boolean }>`
  transition: all 0.2s ease;
  border: 1px solid ${p => p.theme.colors.shades[400]};
  &:focus-within,
  &:hover {
    border-color: ${p => p.theme.colors.shades[800]};
  }

  ${p =>
    ['finished', 'loading'].includes(p.status) &&
    css`
      border-color: ${p => p.theme.colors.shades[800]};
      ${Button} {
        color: #fff;
        background: ${p => p.theme.colors.shades[800]};
      }
    `}

  ${p =>
    p.hasError &&
    p.status === 'idle' &&
    `
      border-color: ${p.theme.colors.error}!important;
    `}

  input {
    border: none !important;
    box-shadow: none !important;
  }
`

type Props = InputProps & {
  label: string
  formStatus?: 'loading' | 'finished' | 'idle'
}

export const InlinedFieldControl: FC<Props> = ({ label, formStatus = 'idle', status, ...rest }) => {
  return (
    <Container
      display="grid"
      gridTemplateColumns={{ _: 'auto 3rem', small: 'auto 3.5rem' }}
      status={formStatus}
      hasError={status === 'error'}
    >
      <Box position="relative">
        <Input {...rest} />
        {label && <AnimatedLabel>{label}</AnimatedLabel>}
      </Box>
      <Button
        type="submit"
        disabled={['loading', 'finished'].includes(formStatus) || status === 'error'}
      >
        {formStatus === 'idle' && <Icon size={32} icon="chevron-right-small"></Icon>}
        {formStatus === 'finished' && <Icon size={32} icon="check"></Icon>}
        {formStatus === 'loading' && <Spinner size={16} />}
      </Button>
    </Container>
  )
}

export default InlinedFieldControl
